import { useState, useEffect } from 'react';
import { saveEmployeeInfo, hasEmployeeInfo } from '@/utils/storage';

interface Props {
  onRegistered: () => void;
}

const COMPANY_OPTIONS = [
  '文投控股本部',
  '影城板块-影管公司',
  '影城板块-影城公司',
  '游戏板块-上海都玩',
  '游戏板块-弘数科技',
  '文化附加板块',
];

export default function EmployeeModal({ onRegistered }: Props) {
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasEmployeeInfo()) {
      onRegistered();
    }
  }, [onRegistered]);

  const handleSubmit = () => {
    if (!name.trim()) {
      setError('请填写姓名');
      return;
    }
    if (!company) {
      setError('请选择所属公司');
      return;
    }
    if (!phone.trim() || !/^1[3-9]\d{9}$/.test(phone.trim())) {
      setError('请填写正确的手机号');
      return;
    }
    saveEmployeeInfo({ name: name.trim(), company, phone: phone.trim() });
    onRegistered();
  };

  if (hasEmployeeInfo()) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-8 animate-fade-in">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800">欢迎使用合同生成工具</h2>
          <p className="text-gray-500 mt-2">请先登记您的信息，以便记录合同生成情况</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">姓名 <span className="text-red-500">*</span></label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="请输入您的姓名"
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">所属公司 <span className="text-red-500">*</span></label>
            <select
              value={company}
              onChange={e => setCompany(e.target.value)}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition bg-white"
            >
              <option value="">请选择所属公司</option>
              {COMPANY_OPTIONS.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">手机号 <span className="text-red-500">*</span></label>
            <input
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="请输入您的手机号"
              maxLength={11}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition"
            />
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full mt-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition shadow-lg shadow-primary/25"
        >
          进入系统
        </button>
      </div>
    </div>
  );
}
